<template>
  <div>
    <v-app-bar absolute src="@/assets/fondo_app.jpg" height="300">
      <v-row>
        <v-col cols="12" md="12" class="text-start">
            <v-img src="@/assets/logoTuTaxi.png" max-height="200" max-width="200"></v-img>  
        </v-col>
        <v-col cols="12" md="12" class="mt-n5 text-end">
          <strong class="text-h6 black--text">La evolución digital para Radiotaxis</strong>
        </v-col>
      </v-row>
    </v-app-bar>
        <!-- <v-img src="@/assets/fondo_app.jpg" max-height="300"></v-img> -->
    <v-sheet style="background-color: #f4cf2f;">
      <v-row>
        <v-col cols="12" md="12" class="text-center">
            <img src="@/assets/logoTuTaxi.png" height="200" width="200"></img>
        </v-col>
      </v-row>
      <v-row class="mt-n7">
        <v-col cols="12" md="12" class="text-center">
          <strong class="text-h6">La evolución digital para Radiotaxis</strong>
        </v-col>
        <v-col cols="12" md="12" class="mt-n5">&nbsp;</v-col>
      </v-row>
    </v-sheet>
    <v-container>
      <div class="mt-10">
        <v-row>
          <v-col cols="12" md="12" class="text-center">
            <h2>Olvídate de las llamadas telefónicas 24/7</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1" md="3"></v-col>
          <v-col cols="10" md="6" class="text-center">
            <p class="mt-n2 text-justify text-subtitle-1">TuTaxiApp automatiza la solicitud, asignación y seguimiento de viajes. Cada servicio queda registrado desde su solicitud hasta su finalización, entregando control total a los dueños de radiotaxis.</p>
          </v-col>
          <v-col cols="1" md="3"></v-col>
        </v-row>
      </div>
    </v-container>
    <div style="background-color: #f5f5f5;">
      <v-container>
        <h2 class="mt-2 mb-2">¿Qué puedes controlar?</h2>
        <v-row class="mt-2">
          <v-col cols="12" md="4">
            <v-card rounded height="65">
              <v-container>
                <div class="mt-2">
                  📍 Seguimiento en tiempo real.
                </div>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card rounded height="65">
              <v-container>
                <div class="mt-2">
                  💰 Administración de tarifas y recorridos.
                </div>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card rounded>
              <v-container>
                <div class="mt-2">
                  🚖 Control completo de la flota.
                </div>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card rounded>
              <v-container>
                <div class="mt-2">
                  📊 Liquidación y gestión de conductores.
                </div>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card rounded>
              <v-container>
                <div class="mt-2">
                  📁 Historial completo de viajes.
                </div>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card rounded>
              <v-container>
                <div class="mt-2">
                  🕒 Operación automática 24/7.
                </div>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        
        <v-row class="mt-5">
          <v-col cols="12" md="8">
            <h2>Únete a la comunidad TuTaxiApp</h2>
            <v-card rounded>
              <v-container>
                <h2 class="mt-10 mb-2">Formulario Contacto</h2>
                <v-row class="mt-8">
                  <v-col cols="12" md="12" class="mt-n8">
                    <v-text-field label="Nombre RadioTaxi" class='text-body-2' v-model="nombre_taxi" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="mt-n8">
                    <v-text-field label="Rut Representante" class='text-body-2' v-model="rut_representante" dense outlined rounded style="width:200px"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8" class="mt-n8">
                    <v-text-field label="Nombre Representante" class='text-body-2' v-model="nombre_representante" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" class="mt-n8">
                    <v-text-field label="Dirección" class='text-body-2' v-model="direccion" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n8">
                    <v-text-field label="Comuna" class='text-body-2' v-model="comuna" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n8">
                    <v-text-field label="Ciudad" class='text-body-2' v-model="ciudad" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n8">
                    <v-text-field label="Email" class='text-body-2' v-model="email" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n8">
                    <v-text-field label="Telefono" class='text-body-2' v-model="telefono" dense outlined rounded></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n5">
                    <v-btn @click="enviar()" color="#d62828" dark>
                      <span class="text-caption">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Enviar Solicitud
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n5">
                    <div v-if="envio==true">
                      <v-icon class="mr-2" large color="success">check_circle</v-icon>
                      <strong class="text-body-2 success--text">Tú solicitid fue enviada con exito</strong>
                    </div>
                    <div v-if="envio==false">
                      <v-icon class="mr-2" large color="error">cancel</v-icon>
                      <strong class="text-body-2 error--text">Todos los datos son obligatorios</strong>
                    </div>
                  </v-col>
                  <v-col cols="12" md="12"></v-col>
                </v-row>
              </v-container>
            </v-card>
            <h5 class="mt-2">Una vez recibido el formulario, TuTaxiApp enviará toda la información necesaria para registrar su flota y comenzar a operar.</h5>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <div style="margin-top:150px;">
              <img src="@/assets/email.png" height="200" width="200"></img>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <h2>TuTaxiApp User</h2>
            <img src="@/assets/user.png" height="500" width="250" style="border-radius: 50px;"></img>
          </v-col>
          <v-col cols="12" md="3">
            <div style="margin-top:50px">
              <v-img src="@/assets/logo_user_cuadrado.png" max-height="150" max-width="150"></v-img>
              <span class="text-caption font-italic">Disponible</span>
              <a href="https://play.google.com/store/apps/details?id=com.tutaxiuser.app&pcampaignid=web_share">
                <v-img src="@/assets/Google_Play.png" max-height="50" max-width="200"></v-img>
              </a>
              <span class="text-caption font-italic">TuTaxiApp User</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <h2>TuTaxiApp Driver</h2>
            <img src="@/assets/driver.png" height="500" width="250" style="border-radius: 50px;"></img>
          </v-col>
          <v-col cols="12" md="3">
            <div style="margin-top:50px">
              <v-img src="@/assets/logo_driver_cuadrado.png" max-height="150" max-width="150"></v-img>
              <span class="text-caption font-italic">Disponible</span>
              <a href="https://play.google.com/store/apps/details?id=com.tutaxidriver.app&pcampaignid=web_share">
                <v-img src="@/assets/Google_Play.png" max-height="50" max-width="200"></v-img>
              </a>
              <span class="text-caption font-italic">TuTaxiApp Driver</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-footer color="#ffd630">
      <v-row>
        <v-col cols="12" md="12" class="text-center">
          Chile, {{ new Date().getFullYear() }} — <strong>TuTaxiApp</strong>
          <h6 class="font-italic">tutaxiappchile@gmail.com</h6>
        </v-col>
      </v-row>
    </v-footer>  
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: 'Home',
  data: () => ({
    nombre_taxi:'',
    rut_representante:'',
    nombre_representante:'',
    direccion:'',
    comuna:'',
    ciudad:'',
    email:'',
    telefono:'',
    envio:null,
  }),
  async mounted(){
  },
  methods:{
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    async enviar(){
      try {
        if(this.nombre_taxi!='' && this.rut_representante!='' && this.nombre_representante!='' &&
            this.direccion!='' && this.comuna!='' && this.ciudad!='' && this.email!='' && this.telefono!='')
        {
          let empresa = this.nombre_taxi;
          let remitente = 'dte@bodeganet.cl';//this.email;
          let destinatario = 'tutaxiappchile@gmail.com';
          let asunto = 'Solicitud de registro';
          let html = "";
          html = html + " <table width='100%'>";
          html = html + "  <tr>";
          html = html + "   <td style='width:10%'></td>";
          html = html + "   <td style='width:80%'>";
          html = html + "    <table width='100%' style='background-color: #f5f5f5; border-radius: 10px;'>";
          html = html + "     <tr>";
          html = html + "      <td style='width:20%'></td>";
          html = html + "      <td style='width:80%'>";
          html = html + "       <br><br>";
          html = html + "       <span> <strong>Nombre RadioTaxi:</strong> " + this.nombre_taxi + "</span><br>";  
          html = html + "       <span> <strong>Rut Representante:</strong> " + this.rut_representante + "</span><br>";  
          html = html + "       <span> <strong>Nombre Representante:</strong> " + this.nombre_representante + "</span><br>";  
          html = html + "       <span> <strong>Direccion:</strong> " + this.direccion + "</span><br>";  
          html = html + "       <span> <strong>Comuna:</strong> " + this.comuna + "</span><br>";  
          html = html + "       <span> <strong>Ciudad:</strong> " + this.ciudad + "</span><br>";  
          html = html + "       <span> <strong>Email:</strong> " + this.email + "</span><br>";  
          html = html + "       <span> <strong>Telefono:</strong> " + this.telefono + "</span>";  
          html = html + "       <br><br>";
          html = html + "      </td>";
          html = html + "      <td style='width:20%'></td>";
          html = html + "     </tr>";
          html = html + "    </table>";
          html = html + "   </td>";
          html = html + "   <td style='width:10%'></td>";
          html = html + "  </tr>";
          html = html + " </table>";
          let cuerpo = html;
          let InstFormData = new FormData();
          InstFormData.append('empresa' , empresa);
          InstFormData.append('remitente' , remitente);
          InstFormData.append('destinatario' , destinatario);
          InstFormData.append('asunto' , asunto);
          InstFormData.append('cuerpo' , cuerpo);
          const response= await axios.post('https://www.app.bodeganet.cl/ApiPHP_ClientesPWA/public/api/server/sender/email/', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
          console.log('envio email', response.data);
          this.envio=true;
          setTimeout(() => {
            this.clsInput();
          }, 5000);
        } else {
          this.envio=false;
          setTimeout(() => {
            this.envio=null;
          }, 5000);
        }
      } catch (error) {
        console.log(error)
      }
    },
    clsInput(){
      this.nombre_taxi='';
      this.rut_representante='';
      this.nombre_representante='';
      this.direccion='';
      this.comuna='';
      this.ciudad='';
      this.email='';
      this.telefono='';
      this.envio=null;
    }
  }
}
</script>
